import { render } from "./grn.vue?vue&type=template&id=5bff6eb2"
import script from "./grn.vue?vue&type=script&lang=js"
export * from "./grn.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__